import {
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    TextField,
    Typography,
} from "@mui/material";
import debounce from "lodash.debounce";
import { useMemo, useState } from "react";

import { getAllPlayoffs } from "../../../apis/Playoff";

export const PlayoffSearchDrawer = ({
    bucket,
    selectedPlayoffs,
    setSelectedPlayoffs,
    setEditOpen,
}) => {
    const [options, setOptions] = useState([]);
    // const [selectedPlayoffs, setSelectedPlayoffs] = useState([]);
    const [loading, setLoading] = useState(false);

    const debouncedSearch = useMemo(
        () =>
            debounce(async (query) => {
                if (!query) {
                    setOptions([]);
                    return;
                }

                try {
                    setLoading(true);

                    const response = await getAllPlayoffs(
                        10,
                        1,
                        {
                            search: query,
                        }
                    );

                    setOptions(response.results || []);
                } catch (error) {
                    console.error(error);
                    setOptions([]);
                } finally {
                    setLoading(false);
                }
            }, 500),
        []
    );

    const handleAddSelected = () => {
        console.log("Bucket:", bucket);
        console.log("Selected PlayOffs:", selectedPlayoffs);

        // API integration comes next

        setEditOpen(false);
    };

    return (
        <Box p={5}>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={4}
            >
                <Typography variant="h6">
                    Search PlayOffs
                </Typography>

                <Button
                    variant="contained"
                    disabled={!selectedPlayoffs.length}
                    onClick={handleAddSelected}
                >
                    Add Selected
                </Button>
            </Box>

            <Autocomplete
                multiple
                options={options}
                value={selectedPlayoffs}
                loading={loading}
                filterSelectedOptions
                getOptionLabel={(option) =>
                    option?.title || ""
                }
                isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                }
                onChange={(_, value) => {
                    setSelectedPlayoffs(value);
                }}
                onInputChange={(_, value) => {
                    debouncedSearch(value);
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Search PlayOffs"
                        placeholder="Search by PlayOff name"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {loading && (
                                        <CircularProgress
                                            size={20}
                                        />
                                    )}

                                    {
                                        params.InputProps
                                            .endAdornment
                                    }
                                </>
                            ),
                        }}
                    />
                )}
            />
        </Box>
    );
};